// @ts-strict-ignore
import * as React from 'react';

// TODO(Lexicon Refactor): replace in other usages within React-based components
// TODO(Lexicon Refactor): maxLength option not ported over since usage in Lexicon already uses text-overflow, add back in when replaced in other usages
export function formatTextReact(text: string, {
  className = ``
}: {
  className?: string;
} = {}, inlineElements: React.ReactElement[] = []) {
  // This regex matches naked links and markdown-formatted links
  // e.g [google](https://google.com) and https://google.com and mailto:email@mixpanel.com
  const urlRegex = /\[([^\]]+)\]\(((https?:\/\/\S+)|(mailto:\S+)|(\/\S*))\)(?:{:target="([a-z_]+)"})?|(https?:\/\/\S+)/gm;
  // parse text into span / anchor parts
  const parsedOutput = [];
  let lastIndex = 0;
  let urlMatch: RegExpExecArray;
  do {
    urlMatch = urlRegex.exec(text);
    if (urlMatch) {
      // add text upto link
      parsedOutput.push(<span key={lastIndex}>{text.slice(lastIndex, urlMatch.index)}</span>);
      const [fullMatch, mdLinkText, mdLinkHref] = urlMatch;
      const nakedLinkHref = urlMatch[7];
      if (nakedLinkHref) {
        parsedOutput.push(<a key={nakedLinkHref} href={nakedLinkHref} target='_blank'>
            {nakedLinkHref}
          </a>);
      } else if (mdLinkText) {
        parsedOutput.push(<a key={mdLinkText} href={mdLinkHref} target={urlMatch[6] || `_blank`}>
            {mdLinkText}
          </a>);
      }
      lastIndex = urlMatch.index + fullMatch.length;
    }
  } while (urlMatch !== null);
  // add remaining text
  const remainingText = text.slice(lastIndex);
  parsedOutput.push(<span key={remainingText}>{remainingText}</span>);
  for (const inlineElement of inlineElements) {
    parsedOutput.push(inlineElement);
  }
  return <div className={className ? className : ``} data-sentry-component="formatTextReact" data-sentry-source-file="format-text-react.tsx">{parsedOutput}</div>;
}